import { localStorageKeys } from '../constants/localStorage';

const authStorage = {
  remove: (): void => localStorage.removeItem(localStorageKeys.auth),
  set: (value: string): void => localStorage.setItem(localStorageKeys.auth, value),
  get: (): string => localStorage.getItem(localStorageKeys.auth) as string,
};

export default authStorage;
